import { Navigate, Route, Routes } from "react-router-dom";
import { CancelPage } from "./pages/CancelPage";
import { CodeRoute } from "./pages/CodeRoute";
import { RepairRequestPage } from "./pages/RepairRequestPage";

export function App() {
  return (
    <Routes>
      <Route path="/r/:code" element={<RepairRequestPage />} />
      <Route path="/:code" element={<CodeRoute />} />
      <Route path="/:code/cancel/:appointmentId" element={<CancelPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
